import { render, staticRenderFns } from "./WebApps.vue?vue&type=template&id=6b50ddd5&"
import script from "./WebApps.vue?vue&type=script&lang=js&"
export * from "./WebApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports